import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { Reveal, scrollToId } from "@/components/Motion";
import { ASSETS, NAV_LINKS } from "@/data/content";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="footer"
      className="relative bg-[#0a0a12]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr] gap-14">
          {/* Brand + contact */}
          <div>
            <div className="flex items-center gap-3">
              <img
                src={ASSETS.rhino}
                alt="Hacktonomy"
                className="h-12 w-12 object-contain"
              />
              <span className="font-display font-700 text-2xl tracking-tight text-[#97b8ff]">
                hackTonomy
              </span>
            </div>
            <p className="mt-6 font-body text-sm text-white/60 max-w-sm leading-relaxed">
              A premium emerging tech learning platform empowering professionals
              through real world simulations, practical labs and expert led
              training.
            </p>

            <div className="mt-8 space-y-3" data-testid="contact-us">
              <a
                href="mailto:info@cyberfrat.com"
                data-testid="contact-email"
                className="flex items-center gap-3 font-mono2 text-sm text-white/80 hover:text-[#16fcfb] transition-colors"
              >
                <Mail size={15} className="text-[#16fcfb]" /> info@cyberfrat.com
              </a>
              <a
                href="tel:+918927002700"
                data-testid="contact-phone"
                className="flex items-center gap-3 font-mono2 text-sm text-white/80 hover:text-[#16fcfb] transition-colors"
              >
                <Phone size={15} className="text-[#16fcfb]" /> +91 89 2700 2700
              </a>
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-[#97b8ff]">
              Explore
            </h4>
            <ul className="mt-6 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="group inline-flex items-center gap-1 font-body text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {l.label}
                    <ArrowUpRight
                      size={13}
                      className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all text-[#16fcfb]"
                    />
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Training partner */}
          <div>
            <h4 className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-[#97b8ff]">
              Training Partner
            </h4>
            <a
              href="https://cyberfrat.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cyberfrat-logo"
              className="mt-6 inline-flex rounded-xl bg-white px-5 py-3 border border-[#3d414f] transition-transform duration-300 hover:scale-[1.03]"
            >
              <img
                src={ASSETS.cyberfrat}
                alt="CyberFrat"
                className="h-8 object-contain"
              />
            </a>
            <p className="mt-4 font-body text-sm text-white/50">
              Delivered in partnership with CyberFrat.
            </p>
          </div>
        </div>

        <Reveal>
          <div className="mt-16 pt-8 border-t border-[#3d414f] flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-mono2 text-xs text-white/50">
              Copyrights: 2026, CyberFrat | Hacktonomy
            </p>
            {/* <p className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-[#3d414f]">
              Secure the AI Frontier
            </p> */}

            <Link
              to="/privacy-policy"
              className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-[#97b8ff] hover:text-[#16fcfb] transition-colors"
            >
              Privacy Policy & Terms and Conditions
            </Link>
          </div>
        </Reveal>
      </div>
    </footer>
  );
};

export default Footer;
